import { Component, OnInit } from '@angular/core';
import { DashboadDataService } from 'src/app/services/dashboad-service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  dashboardTotalizer: any;

  constructor(public service: DashboadDataService) { }

  ngOnInit(): void {
    this.service.getDashboardTotalizer().subscribe(resp=>{
      if(resp.success == true){
          this.dashboardTotalizer = resp.data;
      }
  });
  }

}
